import { createSignal } from '@funtech-int/rival';
import { nanoid } from 'nanoid';

export const clearPsid = () => psidVar.set(null);

const psidVar = createSignal<string | null>(null);

export const getPsid = () => {
    const psid = psidVar.get();

    if (psid === null) {
        const newPsid = nanoid();
        psidVar.set(newPsid);
        return newPsid;
    }

    return psid;
};
